import React, { FC } from 'react';
import { useLocalizationContext } from 'shared/lib/localization';
import { LocaleProps } from '../locale';
import { replaceLink } from './replaceLink';

export interface LocaleWithLinkProps extends LocaleProps {
    localizationKey: string;
    attributes?: Record<string, Record<string, any>>;
    color?: string;
}

export const LocaleWithLink: FC<LocaleWithLinkProps> = ({
    localizationKey,
    attributes,
    color,
    ...rest
}) => {
    const { localizationService } = useLocalizationContext();
    const localizedString = localizationService.get(localizationKey, rest.params);

    return <>{replaceLink({ localizedString, additionalAttributes: attributes, color })}</>;
};
